<template>
  <div>
     <div class="content-box" v-if="showContent">
        <div class="box" v-show="step==1 || step==3 || step==4">
          <!-- 头部数据-->
          <div class="top-header" :class="{ 'header-fixed': isFixed }" :style="isFixed ? { background: `linear-gradient(to right, ${color || '#6197B1'}, ${backcolor || '#B4CCF6'})` } : {}">
            <div id="spreadmsed" v-show="videoLink  && showVideo" style="padding-top: 150px;width: 750px;" :style="{ transition: 'all 0.3s', opacity: showVideo ? 1 : 0 }"> </div>
            <header ref="headerBox" :style="{ background: `linear-gradient(to right, ${color || '#6197B1'}, ${backcolor || '#B4CCF6'})` }">
              <div class="tag-container" v-show="showCategory">
                  <div class="tag-row" v-for="(row, rowIndex) in groupedCategories" :key="rowIndex" >
                    <div class="tag "  v-for="(item,s) in row"  :class="{ 'tag-active': cate_id === item.id }" @click="chooseCate(item.id)">{{ item.name }}</div>
                  </div>
                
              </div>
              <div class="search-box">
                <div style="display: flex;background: #F7F8FA;border-radius: 50px;margin-bottom: 5px;">
                  <van-search style="width: 120px;height: 34px;font-size: 14px;" v-model="params.key" placeholder="搜索视频" shape="round" background="none"/>
                  <div class="btn-search" @click="searchList">搜 索</div>
                </div>
              <!-- <div class="searcn-new" @click="diushi">点击收藏</div> -->
                <div class="search-new-btn" @click="diushi"  :style="{background:charIndex==1 || charIndex==3?'linear-gradient(to bottom,#FF2,#FB0)':'linear-gradient(150deg,#FFFFB8 10%,#FFFFB8 100%)'}"><i style="color:#E44E3A;margin-top: 2px;" class="fa fa-heart"
                    aria-hidden="true"></i>{{ typedText }}</div>
              <div class="searcn-new" @click="webspread"> <i class="fa fa-angle-double-down" style="color:#E44E3A;margin-right: 4px;font-weight: 700;"></i>账户中心 </div>
              </div>
            </header>
          </div>
          <!-- 头部数据-->
          <!-- 列表数据-->
          <div class="list" :style="{paddingTop:headerHeight+'px'}"  v-show="step==1">
            <van-list
              v-model="loading"
              :immediate-check="true" 
              loading-text="加载中..." 
              :finished="finished"
              finished-text="没有更多了"
              @load="doGetList"
              offset="800"
              direction="down"
            >
              <div class="list-box">
                  <div class="list-item" v-for="(item,index) in dataList" :key="index" >
                    
                    <img v-if="item.is_collect==0 && params.today!=1" class="heart" src="../assets/heart1.png" alt="" @click="collect(item.id,index)"/>
                    <img v-if="item.is_collect==1  && params.today!=1" class="heart" src="../assets/heart2.png" alt="" @click="resetCollect(item.id,index)"/>
                    <div class="img-wrap" @click="getDetail(item)">
                      <div v-if="item.thumb_image" class="thumb" >
                          <!-- <span class="times" v-if="item.times">时长:{{item.times}}</span> -->
                          <span class="today" v-if="params.today==1">{{item.day}}</span>
                          
                          <!-- <img :id="item.number+'_img'" src="" width="100%" @error="resetImgUrl(item.number+'_img',item.thumb_image)" /> -->
                          <img :id="item.number+'_img'" src="" width="100%" v-if="item.is_new==0" />
                          <img :id="item.number+'_img'" :src="item.thumb_image" width="100%" v-if="item.is_new==1" />
                      </div>
                    </div>
                    <div class="video-title" @click="getDetail(item)">{{item.title}}</div>
                  </div>
              </div>
            </van-list>

            <div class="box-tips" v-if="vipInfo.is_vip && params.payed==1 ">
                <div class="tips-title">会员信息</div>
                <div class="tips-txt">当前已开通 <span style="color:red;">{{vipInfo.title}}</span></div>
                <div class="tips-txt">有效期至 <span style="color:red;">{{vipInfo.day}}</span></div>
            </div>
            <div class="box-tips" v-if="vipInfo.is_vip==0 && params.payed==1 && dataList.length==0">
                <div class="tips-title">暂无记录</div>
                <div class="tips-txt">当前没有购买记录，请返回首页列表选购。</div>
            </div>

          </div>

          <div class="list" :style="{paddingTop:headerHeight+'px'}"  v-show="step==3">
            
            <van-list
              v-model="loading"
              :immediate-check="true" 
              loading-text="加载中..." 
              :finished="finished"
              finished-text="没有更多了"
              @load="doGetPayList"
              offset="200"
              direction="down"
            >
            
              <div class="list-box">
                  <div class="list-item" v-for="(item,index) in payDataList" :key="index" :style="{ paddingBottom: '10px', position: 'relative' }">
                    <!-- <div class="shibie-code" @click="showCodeBoxCard(item.code,item.sharecode)">识别码</div> -->
                    <img v-if="item.is_collect==0 && params.today!=1" class="heart" src="../assets/heart1.png" alt="" @click="collect(item.id,index)"/>
                    <img v-if="item.is_collect==1  && params.today!=1" class="heart" src="../assets/heart2.png" alt="" @click="resetCollectFromPay(item.id,index)"/>
                    <div class="img-wrap" @click="getDetail(item)">
                      <div v-if="item.thumb_image" class="thumb" >
                          <!-- <span class="times" v-if="item.times">时长:{{item.times}}</span> -->
                          <span class="today" v-if="params.today==1">{{item.day}}</span>
                          
                          <!-- <img :id="item.number+'_img'" src="" width="100%" @error="resetImgUrl(item.number+'_img',item.thumb_image)" /> -->
                          <img :id="item.number+'_img'" src="" width="100%" v-if="item.is_new==0" />
                          <img :id="item.number+'_img'" :src="item.thumb_image" width="100%" v-if="item.is_new==1" />
                      </div>
                    </div>
                    <div class="video-title" @click="getDetail(item)">{{item.title}}</div>
                  </div>
              </div>
            </van-list>

            <div class="box-tips" v-if="vipInfo.is_vip && params.payed==1 ">
                <div class="tips-title">会员信息</div>
                <div class="tips-txt">当前已开通 <span style="color:red;">{{vipInfo.title}}</span></div>
                <div class="tips-txt">有效期至 <span style="color:red;">{{vipInfo.day}}</span></div>
            </div>
            <div class="box-tips" v-if="vipInfo.is_vip==0 && params.payed==1 && payDataList.length==0">
                <div class="tips-title">暂无记录</div>
                <div class="tips-txt">当前没有购买记录，可通过右侧找回按钮恢复订单。</div>
            </div>
            
          </div>

          <div class="list" :style="{paddingTop:headerHeight+'px'}"  v-show="step==4">
            <van-list
              v-model="loading"
              :immediate-check="true" 
              loading-text="加载中..." 
              :finished="finished"
              finished-text="没有更多了"
              @load="doGetShoucangList"
              offset="200"
              direction="down"
            >
              <div class="list-box">
                  <div class="list-item" v-for="(item,index) in collectList" :key="index" :style="{ paddingBottom: '10px', position: 'relative' }">
                    
                    <img v-if="item.is_collect==0 && params.today!=1" class="heart" src="../assets/heart1.png" alt="" @click="collect(item.id,index)"/>
                    <img v-if="item.is_collect==1  && params.today!=1" class="heart" src="../assets/heart2.png" alt="" @click="resetCollect1(item.id,index)"/>
                    <div class="img-wrap" @click="getDetail(item)">
                      <div v-if="item.thumb_image" class="thumb" >
                          <!-- <span class="times" v-if="item.times">时长:{{item.times}}</span> -->
                          <span class="today" v-if="params.today==1">{{item.day}}</span>
                          
                          <!-- <img :id="item.number+'_img'" src="" width="100%" @error="resetImgUrl(item.number+'_img',item.thumb_image)" /> -->
                          <img :id="item.number+'_img'" src="" width="100%" v-if="item.is_new==0" />
                          <img :id="item.number+'_img'" :src="item.thumb_image" width="100%" v-if="item.is_new==1" />
                      </div>
                    </div>
                    <div class="video-title" @click="getDetail(item)">{{item.title}}</div>
                  </div>
              </div>
            </van-list>
          </div>
          <!-- 列表数据-->
        </div>
        <!-- 视频详情-->
        <div v-show="step==2">
          <div class="box body channelbox" >
            <div id="msed" style="height: 200px;width: 750px;"> </div>
            <div class="player_bot">
                <div>
                    <img src="data:image/png;base64,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" alt="">
                    <p style="font-size: 14px;" >支持点赞</p></div>
                <div id="playId" >
                    <img src="data:image/png;base64,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" alt="">
                    <p style="font-size: 14px;">已购视频</p>
                </div>
                <div  @click="showShoucang=true">
                    <img src="data:image/png;base64,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" alt="">
                    <p style="font-size: 14px;">
                        收藏视频
                    </p>
                </div>
            </div>
            <div class="details" style="width: 100%;padding-top:5px;padding-bottom:15px;border-bottom: 1px solid #f2f2f2;">
                <p style="padding: 5px 10px 5px 10px;">
                    <span > {{linkInfo.title}}</span>
                </p>
            </div>
            <div class="weui-panel__hd" style="text-align: center;font-size: 14px;">相关推荐</div>
            <div class="list"  v-if="detailDataList.length>0 ">
                <van-list
                    v-model="loading"
                    :immediate-check="true" 
                    loading-text="加载中..." 
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="getVideoList(1,'')"
                    offset="200"
                    direction="down"
                >
                    <div class="list-box">
                        <div class="list-item" v-for="(item,index) in detailDataList" :key="index" @click="getDetail(item)" :style="{ paddingBottom: '8px' }">
                        <div class="img-wrap" >
                            <div v-if="item.thumb_image" class="thumb" >
                                <!-- <span class="times" v-if="item.times">时长:{{item.times}}</span> -->
                        
                                <img :id="item.number+'_img'" src="" width="100%" v-if="item.is_new==0" />
                                <img :id="item.number+'_img'" :src="item.thumb_image" width="100%" v-if="item.is_new==1" />
                            </div>
                        </div>
                        <div class="video-title" >{{item.title}}</div>
                        </div>
                    </div>
                </van-list>
            </div>
    
          </div>

        
        </div>
        <!-- 视频详情-->

        <!-- 侧边按钮-->
    
        <div class="cebian" v-if="step==3">
          <div class="ce-shesu" @click="findBox=true">找回</div>
        </div>

        <!-- 个人中心 (step=5) -->
        <div class="list user-center" v-show="step==5">
          <div class="user-card-wrap">
            <div class="user-card-inner">
              <div class="user-avatar">
                <img src="data:image/jpeg;base64,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" alt="avatar" />
              </div>
              <div class="user-account" style="color:#fff;">账号: {{ userInfo.username || '非会员' }}</div>
              <div class="user-code" style="color:#fff;">
                播放口令: {{ shareDataInfo.shareAgentCode || '未获取' }}
                <span class="copy-btn-yellow" @click="handelClickCopy(shareDataInfo.shareAgentCode)">复制</span>
              </div>
              <div class="user-vip-status">
                <div class="vip-tag" style="color:#fff;" v-if="!vipInfo.is_vip">
                  <van-icon name="gem-o" /> 您还不是本站的VIP会员
                </div>
                <div class="vip-tag is-vip" style="color:#fff;" v-else>
                  <van-icon name="gem" /> 尊敬的VIP会员
                </div>
              </div>
            </div>
          </div>

          <div class="user-action-btns">
            <div class="action-btn-item" @click="showLoginBox=true" v-if="!userInfo.username">登录&注册</div>
            <div class="action-btn-item" @click="handleLogout" v-else>退出登录</div>
            <div class="action-btn-item" @click="goPay">成为会员</div>
          </div>

          <div class="user-tips-box">
            <div class="tips-icon"><van-icon name="info-o" /></div>
            <div class="tips-text">
              温馨提示：如果您之前已购买过，没有正常显示，可能是您的网络环境发生了变化，可尝试通过当时购买时的播放口令码进行重新绑定观看。
            </div>
          </div>

          <div class="tousu-float-btn" @click="$toast('暂未开放')">投诉</div>
        </div>
        <!-- 个人中心 (step=5) -->


        <div class="footer-box" :style="{ backgroundImage: `linear-gradient(120deg, ${color || '#6197B1'}, ${backcolor || '#B4CCF6'})` }">
          <div class="foot-item foot-active" @click="goHot"><img style="width: 22px;" src="../assets/fa1.png" />热门</div>
          <div class="foot-item foot-active"  v-if="shareDataInfo.is_live==1" @click="goLive"><i class="fa fa-tv"></i>直播</div>
          <div class="foot-item foot-active" @click="goPay" style="color:#FCB138 !important;"><img style="width: 22px;"
              src="../assets/fa3.png" />已付款</div>
          <div class="foot-item foot-active" @click="shoucang"><i class="fa fa-heart"></i>已收藏</div>

        </div>
        <!-- 底部按钮-->

        <!-- 详情弹窗-->
        <van-dialog class="demo-dialog van-dialog detail-box" v-model="payBoxModal" :style="{ backgroundImage: `linear-gradient(120deg, ${color || '#6197B1'}, ${backcolor || '#B4CCF6'})` }" :before-close="closeDig"  :showConfirmButton="false"  :showCancelButton="false" :closeOnClickOverlay="true">
            <div class="ds_tankuang" v-if="detail.try_see==0">
                <img class="ds_poster" v-if="detail.is_new==0" :id="detail.number+'_ds_poster'" src="" width="100%" @error="resetImgUrl(detail.number+'_ds_poster',detail.thumb_image)" />
                <img class="ds_poster" v-if="detail.is_new==1"  :src="detail.thumb_image" width="100%"  />
            </div>
            <div id="try_mse" style="width:100%;" v-else>
              <video 
              style="width: 100%;height: 100%;object-fit: fill"
                ref="videoPlayer" 
                controls 
                controlslist="nodownload" 
              ></video>
            </div>
            <div  class="ds_title">{{detail.title}}</div>

            <div class="pay-title" style="color:#fff;">付费即可观看完整视频</div>
            <div class="pay-btn-box">
              <van-button round v-for="(item,index) in payBtnList" :key="index" class="index-pay-item" :color="item.color || '#4caf50'" :style="{ background: ' #fff !important', color: item.color+'!important', border: 'none' }" @click="linkTo(item)" > 
                <div style="display: flex;flex-direction: column;">
                  <span  :style="{ color: item.color+'!important', }">{{item.name}}</span>

                </div>
              </van-button>
            </div>
            
            <div class="pay-code-section">
              <div class="pay-code-tip">请及时保存口令，方便找回已购</div>
              <div class="pay-code-box">
                  <div class="pay-code-text">{{shareDataInfo.shareAgentCode}}</div>
                  <div class="pay-code-copy" @click="handelClickCopy(shareDataInfo.shareAgentCode)">复制</div>
              </div>
            </div>

            <div class="pay-action-btns">
                <div class="pay-action-btn collect-btn" @click="collect(detail.id, -1)">收藏本片</div>
                <div class="pay-action-btn close-btn" @click="closeDigNew">关闭</div>
            </div>
        </van-dialog>
        <!-- 详情弹窗-->

      <!-- 支付弹窗-->
        
        <van-action-sheet v-model="payModal111111" title="支付通道">
          <div class="pay-card">
            <div class="pay-list" style="display:flex;align-items: center;flex-direction:row;justify-content: space-around;">
            
                <div class="pay-item" v-for="(item,index) in payList" :key="index" @click="goPayOrder(item.id)" style="display: flex;flex-direction: column;">
                  <img class="picon" style="width: 150px;height: 56px;" src="data:image/png;base64,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" v-if="item.pay_channel=='alipay'">
                  <img class="picon" style="width: 150px;height: 56px;" src="data:image/png;base64,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" v-if="item.pay_channel=='wxpay'">
                  
                  <div class="pay-name" style="display: flex;flex-direction: column;align-items: center;width: 100%;">
                    <span v-if="item.pay_channel=='alipay'" class="txt">推荐使用</span>
                  </div>
              
                </div>
            
              
            </div>
        
          </div>
        </van-action-sheet>
        <!-- 支付弹窗-->

        <van-action-sheet v-model="payModal" title="选择支付方式">
          <div class="pay-card">
            <div class="pay-tips">注意:付款完成后请返回已购观看</div>
            <div class="pay-tips">注意:支付1失败时请更换支付2</div>
            <div class="pay-list" style="">

              <div class="pay-item" v-for="(item, index) in payList" :key="index" @click="goPayOrder(item.id)"
                style="display: flex;flex-direction: column;">
                <div style="background: #fff;border-radius: 6px;display: flex;">
                  <div style="width: 160px; height: 56px;display: flex;justify-content: center;align-items: center;"
                    v-if="item.pay_channel == 'alipay'">
                    <img class="picon" style="width: 120px;height: 46px;"
                      src="data:image/png;base64,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"
                      v-if="item.pay_channel == 'alipay'">
                  </div>
                  <div style="width: 160px; height: 56px;display: flex;justify-content: center;align-items: center;"
                    v-if="item.pay_channel == 'wxpay'">
                    <img class="picon" style="width: 120px;height: 46px;"
                      src="data:image/png;base64,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">
                  </div>
                </div>

                <div class="pay-name"
                  style="display: flex;flex-direction: column;align-items: center;width: 100%;margin: 8px 0;">
                  <!-- <span v-if="item.pay_channel=='alipay'" class="txt">支付宝</span>
                      <span v-if="item.pay_channel=='wxpay'" class="txt">微信</span> -->
                  <span class="txt">通道{{ index + 1 }}</span>
                </div>

              </div>


            </div>

          </div>
        </van-action-sheet>
        <!-- 支付弹窗-->

        <!-- 支付弹窗-->

        <!-- 海报弹窗-->
        <van-dialog class="demo-dialog van-dialog detail-box" v-model="showPosterBox" :style="{ height: '80%', backgroundImage: `linear-gradient(120deg, ${color || '#6197B1'}, ${backcolor || '#B4CCF6'})` }" :showConfirmButton="false"  :showCancelButton="true" :closeOnClickOverlay="true">
          <Poster  :params="params" @save-close="closePoster"></Poster>
        </van-dialog>
        <!-- 海报弹窗-->

        <!-- 登录注册弹窗 -->
        <van-popup v-model="showLoginBox" round closeable position="bottom" :style="{ height: '65%' }">
          <div class="login-box-wrap">
            <div class="login-header">账号登录 / 注册</div>
            <van-tabs v-model="loginTab" class="login-tabs-custom" color="#44A4FF" title-active-color="#44A4FF" :line-width="30" :line-height="3">
              <van-tab title="用户登录">
              
                    <div class="form-container" style="margin-top: 25px;">
                      <van-field v-model="loginForm.username" class="custom-field" placeholder="请输入账号" clearable />
                      <van-field v-model="loginForm.password" class="custom-field" type="password" placeholder="请输入密码" clearable />
                    </div>
            
                  <!-- <van-tab title="快捷口令">
                    <div class="form-container">
                      <van-field v-model="loginForm.code" class="custom-field" placeholder="请输入播放口令码" clearable />
                    </div> -->
                
            
                <div class="submit-btn-wrap">
                  <van-button class="custom-submit-btn" type="info" block round @click="handleLogin">立 即 登 录</van-button>
                </div>
              </van-tab>
              <van-tab title="注册新账号">
                <div class="form-container" style="margin-top: 25px;">
                  <van-field v-model="regForm.username" class="custom-field" placeholder="请输入注册账号" clearable />
                  <van-field v-model="regForm.password" class="custom-field" type="password" placeholder="请输入注册密码" clearable />
                  <van-field v-model="regForm.repassword" class="custom-field" type="password" placeholder="请再次确认密码" clearable />
                </div>
                <div class="submit-btn-wrap">
                  <van-button class="custom-submit-btn" type="info" block round @click="handleRegister">立 即 注 册</van-button>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </van-popup>
        <!-- 登录注册弹窗 -->

        <!-- 弹窗提醒-->
        <van-popup v-model="showRemindBox" 
          closeable
          round 
          close-icon-position="top-right"
          popup-background-color="#ffffff"
          position="center" :style="{ minHeight: '55%' ,width:'90%' }" >
          
        <div class="remind-box">
            <div class="remind-box-title"> 收藏站点 永不迷路</div>
            <div class="remind-title-tips">{{shareDataInfo.tip_content}}</div>
            
            <div class="remind-box-tip1">永久网址:</div>
            <div class="remind-box-link">
              <div class="box-link">{{ shareDataInfo.show_tip_url }}</div>
              <div class="box-copy" @click="handelClickCopy(shareDataInfo.show_tip_url)">复制</div>
            </div>
            
            <div style="display: flex;align-items: center;justify-content: center;margin-top: 10px;">
              <div class="remind-box-tip1" >当前口令:</div>
              <div class="remind-box-link">
                <div class="box-link" style="color:red;background-color: #FEEEF0;padding:2px 4px;border-radius: 5px;">{{shareDataInfo.shareAgentCode}}</div>
                <div class="box-copy" @click="handelClickCopy(shareDataInfo.shareAgentCode)">复制</div>
              </div>
            </div>

            <div class="qrcode-section">
              <div class="remind-box-tip1">截图保存本站二维码:</div>
              <div class="qrcode-wrapper">
                <img v-if="shareDataInfo.qrcodeLink" :src="shareDataInfo.qrcodeLink" class="remind-poster-img" alt="收藏二维码" />
                <!-- 用于长按保存的完整海报（覆盖在内容上方，完全透明） -->
                <!-- <img v-if="remindPosterUrl" :src="remindPosterUrl" class="hidden-poster-overlay" alt="长按保存整张图" /> -->
              </div>
            </div>
        </div>
        </van-popup>
        <!-- 弹窗提醒-->
        <!-- 识别码弹窗-->
        <van-popup v-model="codeBox"  round overlay-class="code-box-back">
            <div class="code-box-card">
              <h3 class="code-box-title">保存购买记录</h3>
              <div class="code-content">
                    <p class="code-txt">识别码</p>
                    <div class="code-txt1">{{shibieCode}}</div>
                    
                </div>
                <div class="code-txt1" style="margin: 0 10px 20px 10px;color:#614385;font-weight: 600;">永久链接:{{shareAgentCode}}</div>
                <div class="code-tips">
                    请妥善保管此识别码，用于后续查询订单信息。
                </div>
                <div style=""> 
                  <div class="code-btn btn-grad" @click="codeBox=false">我已保存</div>
                </div>
                
            </div>
        </van-popup>
        <!-- 识别码弹窗-->


        <!-- 找回-->
        <van-popup v-model="findBox"  round closeable>
            <div class="code-box-card">
              <h3 class="code-box-title">找回购买记录</h3>
              <div class="code-content">
                    <p class="code-txt">识别码</p>
                  <input class="code-input" v-model="video_code" placeholder="请输入识别码"/>
                </div>
                <div class="code-tips">
                    请填写您的口令识别码
                </div>
                <div style=""> 
                  <div class="code-btn btn-grad1" @click="findCodeLog">立即找回</div>
                </div>
                
            </div>
        </van-popup>
        <!-- 找回-->
    </div>
    <!-- <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;margin-top: 100px;line-height: 30px;"> 
      <div style="color: red;">精彩内容正在加载中...</div>
      <div style="color: red;">如长时间加载中,请更换网络使用！</div>
    </div> -->
  </div>
 
</template>
<script>
  import { vlogApi,nc6Api,pvv6Api,iv6Api,vv6Api,cov6Api,vlv6Api,colv6Api,delv6Api,pav7Api,plyv6Api,collv6Api,gvcodApi,userLoginApi,userCodeLoginApi,userRegisterApi,UserInfoApi} from "@/api/api";
  import Poster from '@/components/poster.vue';
  //import Player from 'xgplayer';



import QRCode from "qrcode";
import axios from 'axios';
import { imageUrlToBase64 } from '@/utils/imageUtils';
import CryptoJS from 'crypto-js';
import storage from '@/utils/storage';
import { LevelKey } from 'hls.js';
import bplayer from '@/utils/bplayer';
  export default {
    components: {
      Poster
    },
    data() {
      return {
        payModal111111:false,
        findBox:false,
        codeBox:false,
        showRemindBox:false,
        showPosterBox:false,
        payModal:false,
        payBoxModal: false,
        headerHeight:0,
        categoryList:[],
        step:1,
        cate_id:0,
        loading: false,
        finished: false,
        params:{
          cate_id:0,
          key:'',
          ldk:'',
          payed:'',
          uid:'',
          page:1,
          limit:10,
          templete_id:1,
          webmanage:0,
        },
        dataList:[],
        detailDataList:[],
        collectList:[],
        payDataList:[],
        detail:{
          try_see:0,
          thumb_image:'',
          title:'',
          id:0
        },
        payBtnList:[],
        shebei_type:'',
        payList:[],
        goodsInfo:'',
        vipInfo:{
          title:'',
          day:'',
          is_vip:0
        },
        myKey:'',
        showContent:false,
        try_player:'',
        videoLink:'',
        showVideo: true, // 新增控制变量
        showCategory: true,
        lastScrollTop: 0,
        scrollDirectionThreshold: 10,
        itemsPerRow:7,
        isFixed: true,
        scrollThreshold: 300, // 滚动阈值
        linkInfo:{ },
        try_pay_player:'',
        shareDataInfo:{
          tip_content:'',
          tip_image:'',
          show_tip_url:'',
          tipUrlList:[],
          shareAgentCode:'',
          qrcodeLink:'',
          is_live:0
        },
        remindPosterUrl:'',
        shibieCode:'******',
        video_code:'',
        shareAgentCode:'',
        
        // 个人中心相关
        showLoginBox: false,
        loginTab: 0,
        loginType: 0,
        loginForm: {
          username: '',
          password: '',
          code: ''
        },
        regForm: {
          username: '',
          password: '',
          repassword: ''
        },
        userInfo: {
          username: ''
        },
        color:'',
        backcolor:'',
         fullText: "点击收藏",
      typedText: "",
      charIndex: 0,
      typingTimer: null
      };
    },
    watch: {
      showVideo: {
        handler(newVal) {
          this.$nextTick(() => {
            this.updateHeaderHeight();
          });
        }
      },
      showRemindBox(newVal) {
        if (newVal) {
          this.generateRemindPoster();
        }
      },
      showCategory: {
        handler() {
          this.$nextTick(() => {
            this.updateHeaderHeight();
          });
        }
      },
      categoryList: {
        handler() {
          this.$nextTick(() => {
            this.updateHeaderHeight();
          });
        }
      }
    },
    computed: {
        groupedCategories() {
            const result = [];
            for (let i = 0; i < this.categoryList.length; i += this.itemsPerRow) {
                result.push(this.categoryList.slice(i, i + this.itemsPerRow));
            }
            return result;
        }
    },
    beforeCreate(){
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration:1000
      });
  
    },
    created() {
      
      let that=this;
      // 添加滚动监听
      this.initScrollListener();
      window.addEventListener('resize', this.updateHeaderHeight);
     
     
      //that.getLocalUid();
      //初始化数据
      that.setInitData();
      //获取设备类型
      that.shebei_type=that.getDeviceType();
      //初始化
      that.getInitData();
      //获取分类列表
      that.getCategoryList();
      //获取视频列表
      let cate=this.$route.query.cate;
      if(cate=='payed'){
        that.getVideoList(99,'payed');
      }else{
        that.getVideoList(0,'');
      }
      if(this.$route.query.cate_id){
        this.cate_id=this.$route.query.cate_id;
        this.chooseCate(this.cate_id);
      }
      //获取订单数据
      that.getOrderData();
      that.startTyping();
      that.getUserInfo();
    },
    mounted() {
      let that=this;
      that.$nextTick(() => {
        that.updateHeaderHeight();
      });
      this.lastScrollTop = (window.pageYOffset || document.documentElement.scrollTop || 0);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.updateHeaderHeight);
    },
    methods: {
      startTyping() {
        this.typeNext();
      },
      typeNext() {
        if (this.charIndex < this.fullText.length) {
          this.typedText += this.fullText[this.charIndex];
          this.charIndex++;

          this.typingTimer = setTimeout(this.typeNext, 200); // 打字速度
        } else {
          // 打完停顿1秒再重来
          setTimeout(() => {
            this.typedText = "";
            this.charIndex = 0;
            this.typeNext();
          }, 500);
        }
      },
      findCodeLog(){
        let that=this;
        if(!that.video_code){
          that.$toast('请填写识别码');
          return ;
        }
        gvcodApi({code:that.video_code,ldk:that.params.ldk}).then(res=>{
          let temp=JSON.parse(that.$decryptData(res));
          that.$toast(temp.msg);
          if(temp.code==1){
            that.findBox=false;
            that.video_code='';
            that.goPay();
          }
        });
      },
      showCodeBoxCard(code,agentcode){
        this.shibieCode=code;
        this.shareAgentCode=agentcode;
        this.codeBox=true;
      },
      async generateRemindPoster(){
        const mainUrl = this.shareDataInfo.show_tip_url;
        if (!mainUrl) {
          this.remindPosterUrl = '';
          return;
        }

        try {
          const tempCanvas = document.createElement('canvas');
          const tempCtx = tempCanvas.getContext('2d');
          tempCtx.font = '28px Arial';
          const urlLines = this.wrapCanvasText(tempCtx, mainUrl, 630);

          const qrDataUrl = await QRCode.toDataURL(mainUrl, {
            width: 260,
            margin: 1
          });
          
          // 给前台直接展示二维码赋值
          this.shareDataInfo.qrcodeLink = qrDataUrl;

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const width = 750;
          const height = 1000;
          canvas.width = width;
          canvas.height = height;

          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, width, height);

          let cursorY = 80;

          // 标题
          ctx.fillStyle = '#333333';
          ctx.font = 'bold 40px Arial';
          ctx.textAlign = 'center';
          ctx.fillText('收藏站点 永不迷路', width / 2, cursorY);
          
          // 标题下划线
          cursorY += 40;
          ctx.strokeStyle = '#f5f5f5';
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.moveTo(40, cursorY);
          ctx.lineTo(width - 40, cursorY);
          ctx.stroke();

          // 提示文字
          cursorY += 60;
          ctx.fillStyle = '#f53036';
          ctx.font = 'bold 28px Arial';
          const tipLines = this.wrapCanvasText(ctx, this.shareDataInfo.tip_content || '温馨提示：请妥善保管好我们的网址，以免丢失。每天更新最新资源，超清，超快，超好看！', width - 120);
          tipLines.forEach((line) => {
            ctx.fillText(line, width / 2, cursorY);
            cursorY += 42;
          });

          // 永久网址标题
          cursorY += 30;
          ctx.textAlign = 'center';
          ctx.fillStyle = '#333333';
          ctx.font = '28px Arial';
          ctx.fillText('永久网址：', width / 2, cursorY);

          // 网址内容和复制按钮
          cursorY += 50;
          ctx.fillStyle = '#44A4FF';
          ctx.font = 'bold 34px Arial';
          ctx.textAlign = 'right';
          ctx.fillText(mainUrl, width / 2 + 50, cursorY);
          
          // 画假复制按钮
          ctx.fillStyle = '#44A4FF';
          this.roundRect(ctx, width / 2 + 70, cursorY - 32, 90, 44, 10);
          ctx.fill();
          ctx.fillStyle = '#ffffff';
          ctx.font = '22px Arial';
          ctx.textAlign = 'center';
          ctx.fillText('复制', width / 2 + 115, cursorY - 2);

          // 用户口令
          cursorY += 70;
          ctx.fillStyle = '#333333';
          ctx.font = '28px Arial';
          ctx.textAlign = 'right';
          ctx.fillText('当前用户口令：', width / 2 - 40, cursorY);
          
          ctx.fillStyle = '#44A4FF';
          ctx.font = 'bold 34px Arial';
          ctx.textAlign = 'left';
          ctx.fillText(this.shareDataInfo.shareAgentCode || '******', width / 2 - 30, cursorY);
          
          // 画假复制按钮
          ctx.fillStyle = '#44A4FF';
          this.roundRect(ctx, width / 2 + 160, cursorY - 32, 90, 44, 10);
          ctx.fill();
          ctx.fillStyle = '#ffffff';
          ctx.font = '22px Arial';
          ctx.textAlign = 'center';
          ctx.fillText('复制', width / 2 + 205, cursorY - 2);

          // 二维码提示
          cursorY += 80;
          ctx.fillStyle = '#333333';
          ctx.font = '28px Arial';
          ctx.textAlign = 'center';
          ctx.fillText('截图保存本站二维码：', width / 2, cursorY);

          const qrImage = await this.loadCanvasImage(qrDataUrl);
          const qrSize = 340;
          const qrY = cursorY + 30;
          ctx.drawImage(qrImage, (width - qrSize) / 2, qrY, qrSize, qrSize);

          this.remindPosterUrl = canvas.toDataURL('image/png');
        } catch (error) {
          console.error('生成提醒海报失败:', error);
          this.remindPosterUrl = '';
        }
      },
      roundRect(ctx, x, y, width, height, radius) {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
      },
      wrapCanvasText(ctx, text, maxWidth) {
        if (!text) return [];
        const lines = [];
        let currentLine = '';
        for (const char of text) {
          const testLine = currentLine + char;
          if (ctx.measureText(testLine).width > maxWidth && currentLine) {
            lines.push(currentLine);
            currentLine = char;
          } else {
            currentLine = testLine;
          }
        }
        if (currentLine) {
          lines.push(currentLine);
        }
        return lines;
      },
      loadCanvasImage(src) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = src;
        });
      },
      handelClickCopy(text){
        this.$copyText(text).then(e=>{
          this.$toast('复制成功');
        }).catch(e=>{
          this.$toast('复制失败');
        })
      },
      doGetPayList(){
       
        this.getPayVideoList(1,'payed');
      },
      doGetShoucangList(){
        this.getCollectList();
      },
      closePoster(){
        this.showPosterBox=false;
      },
      collect(video_id,index){
        let that=this;
        let data={
          video_id:video_id,
          uid:that.params.uid,
          ldk:that.params.ldk
        }
        data.sp=window.localStorage.getItem('sp');
            data.ua=window.localStorage.getItem('parent');
        colv6Api(data).then(res=>{
          let temp=JSON.parse(that.$decryptData(res));
          if(temp.code==1){
            if (index >= 0) {
              that.dataList[index].is_collect=1;
            } else {
              that.$toast('收藏成功');
            }
          } else {
            that.$toast(temp.msg || '收藏失败');
          }
        })
      },
      resetCollect(video_id,index){
        let that=this;
        let data={
          video_id:video_id,
          uid:that.params.uid,
          ldk:that.params.ldk
        }
        data.sp=window.localStorage.getItem('sp');
            data.ua=window.localStorage.getItem('parent');
        delv6Api(data).then(res=>{
          let temp=JSON.parse(that.$decryptData(res));
          if(temp.code==1){
            that.dataList[index].is_collect=0;
            
          }
        })
      },
      resetCollectFromPay(video_id,index){
        let that=this;
        let data={
          video_id:video_id,
          uid:that.params.uid,
          ldk:that.params.ldk
        }
        data.sp=window.localStorage.getItem('sp');
        data.ua=window.localStorage.getItem('parent');
        delv6Api(data).then(res=>{
          let temp=JSON.parse(that.$decryptData(res));
          if(temp.code==1){
            that.payDataList[index].is_collect=0;
          }
        })
      },
      resetCollect1(video_id,index){
            let that=this;
            let data={
                video_id:video_id,
                uid:that.params.uid,
                ldk:that.params.ldk,
                
            }
            data.sp=window.localStorage.getItem('sp');
            data.ua=window.localStorage.getItem('parent');
            delv6Api(data).then(res=>{
              let temp=JSON.parse(that.$decryptData(res));
            if(temp.code==1){
                that.dataList[index].is_collect=0;
                that.params.page=1;
                that.dataList=[];
                that.shoucang();
            }
            })
        },
      preView(blob, element) {
        let reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
            const imgElement = document.getElementById(element);
            if (imgElement) {
                imgElement.src = e.target.result;
            }
        };
    },
    jsReadFiles(blob, element) {
        var reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        reader.onload = function () {
            // 转换为 Blob 并显示图片
            var result = new Blob([reader.result.slice(3)], { type: 'image/jpeg' });
            this.preView(result, element); // 显示图片
        }.bind(this);  // 确保 this 指向正确
    },
    resetImgUrl(imageobj, url) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url + '_.pdf', true);
        xmlhttp.responseType = "blob";
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                if (xmlhttp.status === 200) {
                    this.jsReadFiles(xmlhttp.response, imageobj); // 处理图片显示
                } else {
                    // 处理请求错误或返回空图片
                    console.error("Failed to load image", url);
                }
            }
        }.bind(this);  // 确保 this 指向正确
        xmlhttp.send(null);
    },
        goPay(){
          
          this.step=3;
          this.loading = true;
          this.showVideo=false;
          this.payDataList = [];
          this.finished = false;
          this.params.page = 1;
          this.params.payed = 1;
           this.getPayVideoList('payed',''); 
          this.getVipInfo();
          const iframe = document.getElementById('payFrame');
          if (iframe) {
            iframe.remove(); // 清空内容，但元素仍在页面上
          }
        },
        updateHeaderHeight() {
          const headerBox = this.$refs.headerBox;
          let num=0;
          if(this.showVideo && this.videoLink){
            num=150;
          }
          if (headerBox) {
            this.headerHeight = headerBox.offsetHeight +num;
          }
        },
        handleScroll() {
          const scrollTopRaw = window.pageYOffset || document.documentElement.scrollTop;
          const scrollTop = Math.max(scrollTopRaw || 0, 0);

          const delta = scrollTop - this.lastScrollTop;
          if (Math.abs(delta) > this.scrollDirectionThreshold) {
            if (delta > 0 && scrollTop > 0) {
              if (this.showCategory) this.showCategory = false;
            } else {
              if (!this.showCategory) this.showCategory = true;
            }
          }

          if (scrollTop <= 10 && !this.showCategory) {
            this.showCategory = true;
          }

          this.lastScrollTop = scrollTop;
          if (scrollTop > this.scrollThreshold) {
            if (!this.isFixed) {
              this.isFixed = true;
              this.updateHeaderHeight();
            }
          } else if (scrollTop === 0 || scrollTop > 150) {
            this.isFixed = true;
            this.showVideo = false;
            if (this.try_player) {
                this.try_player.destroy();
                this.try_player = '';
            }
            this.videoLink = '';
            this.$nextTick(() => {
              this.updateHeaderHeight();
            });
          }
        },
      initScrollListener() {
          window.addEventListener('scroll', this.handleScroll, {
              passive: true // 提高滚动性能
          });
      },
      createPlayer(videoInfo=null) {
        if (this.try_player) {
                this.try_player.destroy();
                this.try_player = '';
            }
            let self = this;
            this.$nextTick(() =>{
              if(videoInfo){
        
               
                self.try_player = new Player({
                        "id": 'msed',
                          "url": videoInfo.link,
                          "playsinline": true,
                          "poster": videoInfo.thumb_image,
                          "x5-video-player-fullscreen": "false",
                          "x5-video-orientation": "portraint",
                          "x5-video-player-type": "h5",
                          "fluid": true,
                          closeVideoClick: true,
                          closeVideoDblclick: true,
                          closeVideoTouch: true,
                          closePlayerBlur: true,
                          closeControlsBlur: true,
                          closeFocusVideoFocus: true,
                          closePlayVideoFocus: true,
                          enableContextmenu: true
                });
                self.try_player.start();
              }else{
              
               
                self.try_player = new Player({
                        "id": 'spreadmsed',
                        "url": self.videoLink,
                        "playsinline": true,
                        "poster": '',
                        "x5-video-player-fullscreen": "false",
                        "x5-video-orientation": "portraint",
                        "x5-video-player-type": "h5",
                        "fluid": true,
                        closeVideoClick: true,
                        closeVideoDblclick: true,
                        closeVideoTouch: true,
                        closePlayerBlur: true,
                        closeControlsBlur: true,
                        closeFocusVideoFocus: true,
                        closePlayVideoFocus: true,
                        enableContextmenu: true
                });

                self.try_player.start();
              }
            });
       
          
      },
      createDetailPlayer(videoInfo){
        let that=this;
        if (that.try_pay_player) {
          
          that.try_pay_player.pause();
          that.try_pay_player.destroy();
          that.try_pay_player = '';
        }
       
        that.$nextTick(() =>{
          that.try_pay_player = new Player({
                "id": 'msed',
                  "url": videoInfo.link,
                  "playsinline": true,
                  // "poster": videoInfo.thumb_image,
                  "x5-video-player-fullscreen": "false",
                  "x5-video-orientation": "portraint",
                  "x5-video-player-type": "h5",
                  "fluid": true,
                  closeVideoClick: true,
                  closeVideoDblclick: true,
                  closeVideoTouch: true,
                  closePlayerBlur: true,
                  closeControlsBlur: true,
                  closeFocusVideoFocus: true,
                  closePlayVideoFocus: true,
                  enableContextmenu: true
                 
          });
         // 禁止点击事件触发播放/暂停
        const playerElement = document.getElementById('msed');
        playerElement.addEventListener('click', (e) => {
          e.stopPropagation();  // 阻止点击事件冒泡
        });

        // 禁止触摸事件触发播放/暂停
        playerElement.addEventListener('touchend', (e) => {
          e.stopPropagation();  // 阻止触摸事件冒泡
        });


          that.try_pay_player.start();
      });
        
      },
      getOrderData(){
        let that=this;
        let ldk=this.$route.query.ldk;
        let ordno=this.$route.query.ordno;
        if(ldk){
          that.params.ldk=ldk;
          window.localStorage.setItem('ldk',ldk);
        }
       //通过订单号获取订单信息
        if(ordno){
          cov6Api({ordno:ordno}).then(res=>{
            let temp=JSON.parse(that.$decryptData(res));
            if(temp.code==1 && temp.msg=='success'){
              localStorage.setItem('sp',temp.data.ip);
              localStorage.setItem('parent',temp.data.ua);
              //that.$router.push({path:'/detail',query:{vid:temp.data.v_id,ldk:ldk}});
              // console.log(temp);
              that.step=2;
              that.linkInfo=temp.data.video;
              that.createDetailPlayer(temp.data.video);
              
              that.dataList = [];
              that.detailDataList=[];
              that.finished = false;
              that.params.page = 1;
              that.params.payed = 0;
              that.params.cate_id = 0;
              that.getVideoList(-1,'');
              
            }
          });
        }
      },
      setInitData(){
        let templete_id=this.getURLParameter('kt');
          if(!templete_id || templete_id=='undefined'){
            let old_tem=window.localStorage.getItem('templete_id');
            if(old_tem && old_tem=='undefined'){
              templete_id=old_tem;
            }else{
              templete_id=1;
            }
          }
        
        this.params.templete_id=templete_id;
        window.localStorage.setItem('templete_id',templete_id);
        this.params.ldk=this.getURLParameter('ldk');
        this.params.uid=this.getURLParameter('uid');
        if(!this.params.ldk || this.params.ldk=='undefined' || this.params.ldk==''){
          let ldk=this.getKey('ldk');
          if(!ldk){
            this.params.ldk=window.localStorage.getItem('ldk');
          }else{
            this.params.ldk=ldk;
            window.localStorage.setItem('ldk',ldk);
          }
          
        }
        if(!this.params.uid || this.params.uid=='undefined' || this.params.uid==''){
          this.params.uid=window.localStorage.getItem('visitorId');
        }
       
       
      },
      getURLParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      },
      getKey(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.hash);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      },
    
      searchList(){
        if(!this.params.key){
          this.$toast('请输入搜索关键词');
          return;
        }
        this.getVideoList(1,'key');
      },
      getDeviceType() {
          const userAgent = navigator.userAgent || navigator.vendor || window.opera;

          if (/android/i.test(userAgent)) {
              return 1;
          }
          if (/iPad|iPhone|iPod/.test(userAgent)) {
              return 2;
          }
          return -1;
      },
      getDetail(item){
        this.detail=item;
        if(item.is_new==0){
          this.resetImgUrl(item.number+'_ds_poster',item.thumb_image);
        }
        // vlogApi({ldk:this.params.ldk}).then(res=>{ 
        // });
      
        //判断用户是否支付
        if(item.is_pay==1){
          //已支付
          //this.$router.push({path:'/detail',query:{vid:item.id,ldk:this.params.ldk,uid:this.params.uid}});
          let beforestep=this.step;
          this.step=2;

          this.linkInfo=item;
          this.createDetailPlayer(item);
          if(beforestep!=this.step){
            this.dataList = [];
            this.finished = false;
            this.params.page = 1;
            this.params.payed = 0;
            this.params.cate_id = 0;
            this. getVideoList(-1,'');
          }
         
          window.scrollTo({ top: 0, behavior: 'smooth' });

        }else{
          //未支付
          let datas={
              ldk:this.params.ldk,
              uid:this.params.uid,
              vid:item.id
            }
          let localPayBtnList=window.localStorage.getItem('localPayBtnList');
          
          if(localPayBtnList && localPayBtnList!='undefined' && localPayBtnList!=null){
            let temp=JSON.parse(this.$decryptData(localPayBtnList));
            this.payBtnList=temp;
            this.payBoxModal=true;
          }else{
            pvv6Api(datas).then(res=>{
              let temp=JSON.parse(this.$decryptData(res));
              this.payBtnList=temp;
              this.payBoxModal=true;
              window.localStorage.setItem('localPayBtnList',res);
            })
          }
          
        
        }
      },

      goHot(){
        this.step=1;
        this.params.today=0;
        this.dataList = [];
        this.finished = false;
        this.params.page = 1;
        this.params.payed = 0;
        this.params.cate_id = 0;
        this. getVideoList(-1,'');
      },
      shoucang(){
            //this.$router.push({path:'/collect',query:{ldk:this.params.ldk,uid:this.params.uid}});
            this.step=4;
            this.loading = true;
            this.showVideo=false;
            this.collectList = [];
            this.finished = false;
            this.params.page = 1;
            this.params.payed = 0;
            this.getCollectList();
      },
      diushi(){
        this.step=1;
          this.showRemindBox=true;
      },
      getCategoryList(){
        nc6Api({ldk:this.params.ldk}).then(res=>{
          let that=this;
          this.categoryList.push({id:0,name:'全部'});
          let list=JSON.parse(that.$decryptData(res));
            list.map(item => {
              that.categoryList.push(item);
            
            })
          });
      },
      chooseCate(cate_id){
        this.cate_id=cate_id;
        this.params.cate_id=cate_id;

        this.step=1;
        this.params.today=0;
        this.dataList = [];
        this.finished = false;
        this.params.page = 1;
        this.params.payed = 0;
        this.getVideoList(1,'cate');
      },

      webspread(){
        this.step=5;
      },
      handleLogin() {
        if (this.loginType === 0) {
          if (!this.loginForm.username || !this.loginForm.password) {
            return this.$toast('请输入账号和密码');
          }
          userLoginApi(this.loginForm).then(res => {
            if (res && res.code === 1) {
              this.$toast('登录成功');
              this.userInfo = res.data;
              if (res.data.shareAgentCode) {
                this.shareDataInfo.shareAgentCode = res.data.shareAgentCode;
                window.localStorage.setItem('shareAgentCode', res.data.shareAgentCode);
              }
              window.localStorage.setItem('Authorization',res.data.token);
              this.showLoginBox = false;
            }
          });
        } else {
          if (!this.loginForm.code) {
            return this.$toast('请输入播放口令');
          }
          userCodeLoginApi(this.loginForm).then(res => {
            if (res && res.code === 1) {
              this.$toast('口令登录成功');
              this.userInfo = res.data;
              if (res.data.shareAgentCode) {
                this.shareDataInfo.shareAgentCode = res.data.shareAgentCode;
                window.localStorage.setItem('shareAgentCode', res.data.shareAgentCode);
              }
              this.showLoginBox = false;
            }
          });
        }
      },
      getUserInfo(){
        UserInfoApi().then(res => {
          let temp = JSON.parse(this.$decryptData(res));
        // console.log(temp);
          if (temp.is_login === 1) {
            
            if (temp.user) {
              this.shareDataInfo.shareAgentCode = temp.user.shareAgentCode;
              window.localStorage.setItem('shareAgentCode', temp.user.shareAgentCode);
              this.userInfo = temp.user;
            }
          }
        });
      },
      handleRegister() {
        if (!this.regForm.username || !this.regForm.password || !this.regForm.repassword) {
          return this.$toast('请填写完整注册信息');
        }
        if (this.regForm.password !== this.regForm.repassword) {
          return this.$toast('两次密码不一致');
        }
        
        // 关键点：注册时带上初始化获取的口令
        const submitData = {
          ...this.regForm,
          shareAgentCode: this.shareDataInfo.shareAgentCode 
        };

        userRegisterApi(submitData).then(res => {
          if (res && res.code === 1) {
            this.$toast('注册成功，请登录');
            this.loginTab = 0;
            this.loginType = 0;
            this.loginForm.username = this.regForm.username;
          }
        });
      },
      handleLogout() {
        this.userInfo = { username: '' };
        window.localStorage.removeItem('shareAgentCode');
        window.localStorage.removeItem('Authorization');
        this.$toast('已退出登录');
      },

      doGetList(){
        this.params.page++;
        this.getVideoList(1,'');
      },
        getVideoList(index,type){
        let that=this;
        if(type=='cate'){
          that.dataList = [];
          that.finished = false;
          that.params.page = 1;
          that.params.payed = 0;
          that.params.key = ''; 
          if(index==88){
            that.params.today=1;
            that.params.cate_id=0;
          }else{
            that.params.today=0;
          }
          that.params.webmanage=0;
        
        }

        if(type=='mannge'){
          that.dataList = [];
          that.finished = false;
          that.params.page = 1;
          that.params.payed = 0;
          that.params.key = ''; 
          that.params.today=0;
          that.params.cate_id=0;
        }
        that.loading = true;
        if(type=='key'){
          that.dataList = [];
          that.finished = false;
          that.params.page = 1;
          that.params.payed = 0;
          that.params.webmanage=0;
        }
        if(type=='payed'){
          that.showVideo=false;
          that.dataList = [];
          that.finished = false;
          that.params.page = 1;
          that.params.payed = 1;
          that.params.webmanage=0;
          if(!that.params.uid){
            that.params.uid=window.localStorage.getItem('visitorId');
          }
        }
        that.params.sp=window.localStorage.getItem('sp');
        that.params.ua=window.localStorage.getItem('parent');
        vlv6Api(that.params).then(res=>{
          that.loading=false;

          if(res){
            //let temp=JSON.parse(that.$Base64.decode(res.data));
            let temp=JSON.parse(that.$decryptData(res));
            if(that.params.page<temp.last_page){
              let newData=temp.data;
              if(that.step==2){
                that.detailDataList=[...that.detailDataList, ...newData]
                newData.map(item=>{
                
                  if(item.is_new==0){
                    that.resetImgUrl(item.number+'_img',item.thumb_image);
                  }
                
                })
              }else{
                that.dataList=[...that.dataList, ...newData]
                newData.map(item=>{
                
                  if(item.is_new==0){
                    that.resetImgUrl(item.number+'_img',item.thumb_image);
                  }
                
                })
              }
              

              // 增加页码
            that.params.page++;
             
            }else{
             
              that.params.page=1;
              if(that.dataList.length>0){
                that.getVideoList(index,'');
              }else{
                that.finished=true;
              }
             
            }
          }else{
            that.loading=false;
            that.finished=true;

            //Toast.fail('加载失败');

          }
        });

      },
      closeDig(action, done) {
         
          done(); // 关闭提示框
      },
      closeDigNew(){
        this.payBoxModal=false;
        const video = this.$refs.videoPlayer;
        if (video) {
          video.pause(); // 停止播放视频
        }
        this.detail={
            try_see:0,
            thumb_image:'',
            title:'',
            id:0
        }
         
      },
      getInitData(){
        let that=this;
        iv6Api({ldk: that.params.ldk, payed: that.params.payed,shebei_type:that.shebei_type}).then(res=>{
          let temp=JSON.parse(that.$decryptData(res));
          // console.log(temp);
          if(temp.agenturl && temp.agenturl!=''){
            window.location.href=temp.agenturl;
          }
          that.color=temp.color;
          that.backcolor=temp.backcolor;
          setTimeout(()=>{
             that.showContent=true;
          },500);
          that.payList=temp.payList;
          that.payBtnList=JSON.parse(that.$decryptData(temp.payBtnList));
          that.shareDataInfo.tip_content=temp.tip_content;
          that.shareDataInfo.tip_image=temp.tip_image;
          that.shareDataInfo.show_tip_url=temp.show_tip_url;
          that.shareDataInfo.tipUrlList=temp.tipUrlList;
          that.shareDataInfo.shareAgentCode=temp.shareAgentCode;
          that.shareDataInfo.is_live=temp.is_live;
          window.localStorage.setItem('shareAgentCode',temp.shareAgentCode);
          
          if(temp.is_index==1){
            if(temp.is_poster==1){
              that.showPosterBox=true;
            }else{
              that.showRemindBox=true;
              that.generateRemindPoster();
            }
          }
          window.localStorage.setItem('localPayBtnList',temp.payBtnList);
          window.localStorage.setItem('jiekou',temp.jiekou);
          window.localStorage.setItem('payList',JSON.stringify(temp.payList));
          window.localStorage.setItem('IP',temp.ip);
          if(temp.videoLink){
            that.videoLink=temp.videoLink;
            that.createPlayer();
            that.$nextTick(()=>{
              that.updateHeaderHeight();
            })
          }
         
        })
        this.getVipInfo();
      },
      getVipInfo(){
        if(!this.params.uid){
          this.params.uid=window.localStorage.getItem('visitorId');
        }
        let sp=window.localStorage.getItem('sp');
        let ua=window.localStorage.getItem('parent');
        let that=this;
        vv6Api({ldk: this.params.ldk, uid: this.params.uid,sp:sp,ua:ua}).then(res=>{
          let temp=JSON.parse(that.$decryptData(res));
          this.vipInfo=temp;
        })
      },
      linkTo(item){
        this.goodsInfo=item;
        this.payModal=true;

        vlogApi({ldk:this.params.ldk}).then(res=>{ 
        });

      },
      goPayOrder(pay_id){
          let that=this;
          if(!that.goodsInfo){
              that.$toast('请选择影视资源类型');
              return;
          }
         
          let ip=window.localStorage.getItem('IP');
          
          //window.location.href =this.goodsInfo.url +'&pay_id='+pay_id+'&uid='+that.params.uid+'&ip='+ip+'&vid='+that.detail.id;
          let data={pay_id:pay_id,ip:ip,uid:that.params.uid,vid:this.detail.id,ldk:this.params.ldk,is_type:this.goodsInfo.is_type};
          pav7Api(data).then(res=>{
            let temp=JSON.parse(that.$decryptData(res));
            // console.log(temp);
            //return;
            if(temp.code==1){
             if(temp.data.payurl){
                if(temp.data.is_iframe==1){

                  // const iframes= document.getElementById('payFrame');
                  // if (iframes) {
                  //   iframes.remove(); // 清空内容，但元素仍在页面上
                  // }

                  // const isWeibo = /weibo/i.test(navigator.userAgent);
                  // if(isWeibo){
                  //   let iframe = document.createElement('iframe');
                  //   iframe.id = 'payFrame';
                  //   iframe.style.width = '100%';
                  //   iframe.style.height = '500px';
                  //   iframe.src = temp.data.payurl;
                  //   document.body.appendChild(iframe);
                  // }else{
                  //   window.location.href = temp.data.payurl;
                  // }
                   this.$router.push({path:'/pay',query:{payurl:temp.data.payurl}});

                }else{
                  window.location.href = temp.data.payurl;
                }
                
             }
              
            }else{
              that.$toast.fail(temp.msg);
            }
          })
      },
      goLive(){
        this.$router.push({path:'/live',query:{ldk:this.params.ldk,uid:this.params.uid}});
      },
      goLiveCenter(){
        this.$router.push({path:'/liveCenter',query:{ldk:this.params.ldk,uid:this.params.uid}});
      },
      shensu(){
        this.$router.push({path:'/shensu',query:{ldk:this.params.ldk,uid:this.params.uid}});
      },

      getPayVideoList(index,type){
        
        let that=this;
       that.params.cate_id=0;
       that.params.sp=window.localStorage.getItem('sp');
       that.params.ua=window.localStorage.getItem('parent');
       plyv6Api(that.params).then(res=>{
         that.loading=false;
         if(res){
           let temp=JSON.parse(that.$decryptData(res));

           if(that.params.page<=temp.last_page){
             let newData=temp.data;
             that.payDataList=[...that.payDataList, ...newData]
             newData.map(item=>{
               if(item.is_new==0){
                 that.resetImgUrl(item.number+'_img',item.thumb_image);
               }
              
             })

             // 增加页码
           that.params.page++;
            
           }else{
             that.finished=true;
           }
         }else{
           that.loading=false;
           that.finished=true;

           Toast.fail('加载失败');

         }
       });
      },
      getCollectList(){
        let that=this;
       
          that.params.cate_id=0;
          that.params.sp=window.localStorage.getItem('sp');
          that.params.ua=window.localStorage.getItem('parent');
          collv6Api(that.params).then(res=>{
            that.loading=false;
            if(res){
              let temp=JSON.parse(that.$decryptData(res));
              if(that.params.page<=temp.last_page){
                that.params.page++;
                let newData=temp.data;
                that.collectList=[...that.collectList, ...newData]
                newData.map(item=>{
                  if(item.is_new==0){
                    that.resetImgUrl(item.number+'_img',item.thumb_image);
                  }
                
                })
               
              }else{
                that.finished=true;
              }
            }else{
              that.loading=false;
              that.finished=true;
  
              Toast.fail('加载失败');
  
            }
          });
      },
      
    },
  };
</script>

<style lang="scss" scoped>
.code-box-card{
  width: 320px;
  border-radius: 10px;
  min-height: 320px;
  padding:15px;
  display: flex;
  align-items: center;
    flex-direction: column;
  .code-box-title{
    width: 300px;
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
  }

  .code-content{
    background: #f8f8f8;
    margin: 20px 30px;
    padding:20px;
    border-radius: 15px;
    color:rgb(107 114 128);
    width: 280px;
    .code-txt{
      color:rgb(107 114 128);
    }
    .code-txt1{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.5rem;
      line-height: 2rem;
      font-weight: 500;
      margin-top:10px;
      
    }
    .code-input{
      height: 40px;
      border: none;
      margin-top: 20px;
      width: 100%;
      padding-left: 10px;
      border-radius: 5px;
      color:rgb(107 114 128);
    }
    
  }
  .code-tips{
      color:rgb(107 114 128);
      font-size: 14px;
      padding:0 15px;
  }
  .code-btn{
    width: 250px;
    border-radius: 5px;
    color:#fff;
    margin: 20px auto;

  }

  .btn-grad {background-image: linear-gradient(to right, #614385 0%, #516395  51%, #614385  100%)}
         .btn-grad {
            margin: 10px;
            padding: 15px 45px;
            text-align: center;
            text-transform: uppercase;
            transition: 0.5s;
            background-size: 200% auto;
            color: white;            
            box-shadow: 0 0 20px #eee;
            border-radius: 10px;
            display: block;
          }

          .btn-grad:hover {
            background-position: right center; /* change the direction of the change here */
            color: #fff;
            text-decoration: none;
          }

          
         .btn-grad1 {background-image: linear-gradient(to right, #FF8008 0%, #FFC837  51%, #FF8008  100%)}
         .btn-grad1 {
            margin: 10px;
            padding: 15px 45px;
            text-align: center;
            text-transform: uppercase;
            transition: 0.5s;
            background-size: 200% auto;
            color: white;            
            box-shadow: 0 0 20px #eee;
            border-radius: 10px;
            display: block;
          }

          .btn-grad1:hover {
            background-position: right center; /* change the direction of the change here */
            color: #fff;
            text-decoration: none;
          }
         
         
}
:deep(.van-button__text){
  color:#fff;
}
.code-btn{
    width: 250px;
    border-radius: 5px;
    color:#fff;
    margin: 20px auto;

  }

.btn-grad2 {
  margin: 10px auto;
  padding: 10px 45px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  color: white;            
  box-shadow: 0 0 20px #eee;
  border-radius: 5px;
  display: block;
  background: rgba(0, 0, 0, 0.6);
  width:300px;
}


.van-popup--bottom.van-popup--round{
  background-color: #FAACA8;
//background-image: linear-gradient(19deg, #FAACA8 0%, #DDD6F3 100%);
background-image: linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%);
}
 .shibie-code{
  font-size: 14px;
  padding: 5px 10px;
  font-weight: 600;
  color:#fff;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  cursor: pointer;
  right: 0;
  z-index: 99;
  border-radius: 25px;
 }
  .ce-shesu{
    width: 50px;
    height: 50px;
    background-image: linear-gradient(to right, #FF8008 0%, #FFC837 51%, #FF8008 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }
  .remind-box {
    position: relative;
    padding-bottom: 20px;
    background: #fff;
    border-radius: 16px 16px 0 0;
  }
  .remind-title-tips{
    font-weight: 600;
    color:#f53036;
    margin: 16px 24px 8px;
    font-size: 16px;
    line-height: 1.6;
    text-align: center;
  }
  .remind-box-title{
    margin: 0 auto;
    width: 100%;
    padding: 15px 0;
    font-size: 20px;
    background: #fff;
    color: #333;
    display: flex;
    justify-content: center;
    font-weight: 700;
    border-bottom: 1px solid #f5f5f5;
  }
  .remind-box-tip1{
   
   
    display: flex;
    justify-content: center;
    font-size: 16px;
    color: #333;
  }
  .qrcode-section {
    margin-top: 10px;
    text-align: center;
  }
  .qrcode-wrapper {
    position: relative;
    display: inline-block;
    margin-top: 10px;
  }
  .remind-poster-img{
    width: 180px;
    height: 180px;
    background: #fff;
  }
  .hidden-poster-overlay {
    position: absolute;
    top: -300px;
    left: -50%;
    width: 200%;
    height: 600px;
    opacity: 0.01;
    z-index: 999;
  }
  .box-tips{
    margin: 14px;
    padding: 20px;
    box-shadow: 1px 2px 3px 2px #ccc;
    border-radius: 10px;
    .tips-title{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 20px;
    }
    .tips-txt{
      padding:5px;
    }
  }
  #spreadmsed {
    transition: opacity 0.3s ease-in-out;
  }
  header {
            
            width: 100%;
            overflow-x: hidden;
            max-width: 100vw;
          
            /* 添加一些阴影效果增加层次感 */
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            padding:3px 2px 0 2px;
        }

        .tag-container {
            display: flex;
            flex-direction: column;
            // gap: 2px;
            width: 100%;
        }

        .tag-row {
            display: flex;
            gap: 7px;
            width: 100%;
        }

        .tag {
             /* 略微透明的白色背景 */
             color:#fff;
            /*padding: 8px 4px;*/
            border-radius: 4px;
            border: none; /* 移除边框 */
            flex: 1;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #333;
            white-space: nowrap;
            overflow: hidden;
            color:#fff;
            touch-action: manipulation;
            user-select: none;
            position: relative;
            min-width: 0;
            /* 添加阴影提升视觉效果 */

        }

        .tag-active {
            background: #eb1111;
            color: #fff !important;
            border-radius: 5px;
            transform: scale(0.98);
        }

        /* 适配不同屏幕尺寸 */
        @media screen and (max-width: 320px) {
            .tag-row {
                gap: 6px;
            }
            .tag {
                font-size: 20px;
               
            }
        }

        @media screen and (min-width: 321px) and (max-width: 375px) {
            .tag {
                font-size: 20px;
              
            }
        }

        @media screen and (min-width: 376px) {
            .tag {
                font-size: 20px;
               
            }
        }

        /* 适配刘海屏 */
        @supports (padding-top: env(safe-area-inset-top)) {
            header {
                padding-left: calc(2px + env(safe-area-inset-left));
                padding-right: calc(2px + env(safe-area-inset-right));
                
            }
        }

        /* 禁用长按菜单 */
        .tag {
            -webkit-touch-callout: none;
        }

        /* 优化字体渲染 */
        @media screen and (-webkit-min-device-pixel-ratio: 2) {
            .tag {
                -webkit-font-smoothing: subpixel-antialiased;
            }
        }
        @supports (padding-top: env(safe-area-inset-top)) {
            header {
                padding-left: calc(2px + env(safe-area-inset-left));
                padding-right: calc(2px + env(safe-area-inset-right));
            }
            .header-fixed {
                padding-top: env(safe-area-inset-top);
            }
        }
        

        .header-fixed {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 100;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        /* 添加占位元素的样式 */
        .header-placeholder {
            height: 0;
            transition: height 0.3s ease;
        }

        .list {
          position: relative;
          z-index: 1;
        }
        @keyframes blink {
          0%, 100% {
            opacity: 1; /* 完全显示 */
          }
          50% {
            opacity: 0.4; /* 完全透明 */
          }
        }
        .cebian{
          position: fixed; /* 固定位置 */
          right:0px; /* 距离屏幕右侧10px */
          top: 50%; /* 定位到屏幕中间 */
          transform: translateY(-50%); /* 垂直居中 */
          z-index: 1000; /* 确保在页面上方显示 */
          
          .today{
            //background: rgba(255, 255, 255, 0.9); /* 白色背景，80%透明度 */
            background-image: linear-gradient(#fffaaa, #fff000);
            padding: 10px; /* 内边距 */
            border-radius: 5px; /* 圆角 */
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* 添加阴影效果 */
            font-size: 16px; /* 字体大小 */
            line-height: 1.5; /* 行高 */
            color: red; /* 字体颜色 */
            font-weight: bold; /* 字体加粗 */
            text-align: center; /* 文本居中 */
            writing-mode: vertical-rl; /* 垂直排版，文字从上到下显示 */
            transform-origin: center; /* 确保对齐中心 */
            animation: blink 1s infinite; /* 闪烁动画 */
          }
        }

        .heart {
          position: absolute;
          width: 25px;
          height: 25px;
          cursor: pointer;
          right: 0;
          z-index: 99;

        }
    .channelbox{
      #mse {
        background-color: #0d0d0d;
    }
    .shoucang-box{
        padding:10px 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #f8f8f8;
        .shoucang-title{
            font-size: 18px;
            font-weight: 700;
            margin-top: 10px;
        }
        .link-txt{
            font-size: 14px;
            padding: 10px;
            word-wrap: break-word;
            width: 280px;
        }
        .box-img{
            margin-top: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 40px;
            padding: 10px;
            background: #fff;
            border-radius: 8px;
        }
        .down-btn{
            width: 220px;
            height: 35px;
            background-image: linear-gradient(#fffaaa, #fff000) !important;
            margin-bottom: 10px;
            border-radius: 25px;
            border:none;
        }
    }
.player_bot {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    margin-top: 1%;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 10px;
}
.player_bot div {
    font-size: 12px;
    text-align: center;
}
.player_bot div img {
    width: 25px;
    height: 25px;
    margin-bottom: 5px;
    margin-top: 5px;
}
.details p {
    display: inline-block;
    padding-top: 4px;
    width: 100%;
    font-size: 14px !important;
}
.details p img {
    width: 15px;
    height: 15px;
}
.weui-panel__hd {
    padding: 10px;
}
.qrcodelink{
    /*width: 200px; !* 定义容器宽度 *!*/
    word-wrap: break-word; /* 允许在单词内换行 */
    overflow-wrap: break-word; /* 同上，现代浏览器推荐使用 */
    white-space: normal; /* 允许自动换行 */
}
.tuijian{
    font-size: 14px;
    color: red;
    position: absolute;
    width: 100px;
    margin-top: 60px;
    margin-left: 30px;
}

    }    

 

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}    
.remind-box-link {
 
  display: flex;
  justify-content: center;
  align-items: center;

}

.box-link {
  font-size: 18px;
  font-weight: 600;
  color: #44A4FF;
}

.box-copy {
  font-size: 14px !important;
  color: #fff !important;
  background: linear-gradient(#44A4FF, #44A4FF);
  font-weight: 700;
  text-align: center;
  border-radius: 20px;
  padding: 4px 12px;
  margin-left: 20px;
}
.pay-code-section {
  text-align: center;
  margin: 5px auto;
  width: 90%;
}
.pay-code-tip {
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 5px;
}
.pay-code-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  width: 100%;
}
.pay-code-text {
  flex: 1;
  padding: 6px 8px;
  font-size: 14px;
  color: #333;
  background: #fff;
}
.pay-code-copy {
  
  color: #fff;
  padding: 8px 16px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.pay-action-btns {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: 5px auto 10px;
  gap: 10px;
}
.pay-action-btn {
  flex: 1;
  border:1px solid #fff;
  color: #fff;
  text-align: center;
  padding: 8px 0;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}
</style>
